import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import LazyLoad from 'react-lazyload';
import { useStyles } from './styles';
import CustomButton from 'components/CustomButton';
import Image from 'next/image';

export default function ImpactfulPosters() {
  const classes = useStyles();

  return (
    <Box py={7} bgcolor="common.white">
      <LazyLoad offset={100}>
        <Container className={classes.templates}>
          <Box
            className="templates-txt"
            py={4}
            display="flex"
            justifyContent="flex-start"
            flexDirection="column"
          >
            <Typography variant="h2">
              Impactful{' '}
              <span>
                <b>Posters</b>
              </span>
            </Typography>

            <Box mt={4} mb={2} maxWidth={483}>
              <Typography className={classes.paragraph} component="p">
                <b>Stand out at any event</b> or environment with visually stunning posters.
              </Typography>
            </Box>

            <Box mt={2} mb={4} maxWidth={483}>
              <Typography className={classes.paragraph} component="p">
                <b>Create high-quality</b> scientific graphics that capture attention and
                effectively convey your messages.
              </Typography>
            </Box>

            <Box>
              <CustomButton variant="ctaDarkPinkOpenModal">Sign up for free</CustomButton>
              &nbsp;&nbsp;
              <CustomButton
                variant="ctaPinkOpenUrl"
                targetPage="/infographic-templates/format/posters/"
              >
                Create Posters
              </CustomButton>
            </Box>
          </Box>

          <Box ml={9}>
            <Image
              src="/images/home-page/posters.webp"
              alt="posters image"
              loading="lazy"
              width={478}
              height={337}
            />
          </Box>
        </Container>
      </LazyLoad>
    </Box>
  );
}
